export default __webpack_public_path__ + "static/media/Silk-Serif-Light.b5d092b3.otf";